export default "__VITE_ASSET__wGfCavYB__"